function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 13.5V30",
  stroke: "#FDBE67",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 36a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  fill: "#FDBE67"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M24 1.5c12.426 0 22.5 10.074 22.5 22.5S36.426 46.5 24 46.5 1.5 36.426 1.5 24 11.574 1.5 24 1.5z",
  stroke: "#FDBE67",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgAnnouncementYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}
export default SvgAnnouncementYellow;